import * as st from '../state/store';
import { track } from '../analytics';
import { flags } from '../state/flags';

const OPTIONS: Array<{ id: st.BodyChoice; label: string; short: string }> = [
  { id: 'm', label: 'Male', short: 'M' },
  { id: 'f', label: 'Female', short: 'F' },
];

/** Female / Male body switch (F22). A radio group: Tab to it, arrow keys or Enter/Space to choose. */
export function BodySwitch() {
  if (!flags.femaleBody) return null;
  const choose = (b: st.BodyChoice) => {
    if (st.body.value === b) return;
    st.setBody(b);
    track('body_change', { body: b === 'f' ? 'female' : 'male' });
  };
  return (
    <div class="body-switch seg" role="radiogroup" aria-label="Body" data-testid="body-switch">
      {OPTIONS.map((o, i) => (
        <button
          key={o.id}
          type="button"
          role="radio"
          aria-checked={st.body.value === o.id}
          aria-label={`${o.label} body`}
          tabIndex={st.body.value === o.id ? 0 : -1}
          class={st.body.value === o.id ? 'on' : ''}
          onClick={() => choose(o.id)}
          onKeyDown={(e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
              e.stopPropagation();
              const next = OPTIONS[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : OPTIONS.length - 1)) % OPTIONS.length];
              choose(next.id);
              (e.currentTarget.parentElement?.querySelectorAll('button')[OPTIONS.indexOf(next)] as HTMLButtonElement | undefined)?.focus();
            }
          }}
          data-testid={`body-${o.id}`}
        >
          <span class="hide-narrow">{o.label}</span>
          <span class="show-narrow" aria-hidden="true">{o.short}</span>
        </button>
      ))}
    </div>
  );
}
